var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-simple-tooltip',{attrs:{"content":_vm.iconTooltip,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"instruction-icon",class:_vm.iconClass,attrs:{"size":"22"}},on),[_vm._v(" "+_vm._s(_vm.iconName)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }